export const EXTERNAL_LINKS = {
  AGROSALES: process.env.REACT_APP_AGROSALES_URL,
}
